import React from 'react';
import * as S from './DetailsBody.styles';

import DetailsLeftBlock from './DetailsLeftBlock/DetailsLeftBlock';
import DetailsRightBlock from './DetailsRightBlock/DetailsRightBlock';

const DetailsBody = ({bookingDetails, hotelDetails, actionLinks, paymentDetails, bookingInfo, trip_type, impInfo, policiesInfo}) => {
  return(
    <S.DetailBodyMainWrap>
      <DetailsLeftBlock bookingDetails={bookingDetails} hotelDetails={hotelDetails} bookingInfo={bookingInfo} trip_type={trip_type} impInfo={impInfo} policiesInfo={policiesInfo} />
      <DetailsRightBlock actionLinks={actionLinks} paymentDetails={paymentDetails} />
    </S.DetailBodyMainWrap> 
  );
}

export default DetailsBody;